import {html} from 'lit-html';
import {live} from 'lit-html/directives/live';
import {repeat} from 'lit-html/directives/repeat';
import {classMap} from 'lit-html/directives/class-map';
import {styleMap} from 'lit-html/directives/style-map';
import {ifDefined} from 'lit-html/directives/if-defined';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';

import TemplateRegistry from '../template/template-registry';
import {ThemeCurrency} from '../const';
import {
    optionName, optionClassMap, optionValueClassMap, optionValueText, optionValuePriceText,
    sizeClassMap, valueSync, swatchToggle, buttonStyleMap, controllerMultiSelect,
    swatchGroupTemplate
} from '../template/template-util.js';

TemplateRegistry.templates['button-swatch'] = (option, config, onChange) => {
    // NEW: multi select support
    if(option.params.multiSelect){

        // get or create multi select controller
        option._controller = option._controller || controllerMultiSelect(option, config, onChange);

        const checkboxTemplate = (optionValue, index) => html`
            <label class="cl-po--swatch-item ${classMap(optionValueClassMap(option, optionValue, { grow: option.params.grow }))}">
                <input type="checkbox" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" .value=${optionValue.value} @change=${(e) => option._controller.onChange(e, option)}
                       .checked=${live(option._controller.isSelected(option,optionValue))} ?disabled=${optionValue.disabled} form=${ifDefined(config.productFormLink)}>
                <div class="cl-po--swatch cl-po--swatch-button ${classMap(sizeClassMap(option, 'small'))}" style=${styleMap(buttonStyleMap(option))} data-tippy-content="${ifDefined(option.params.valuePriceTooltip ? optionValuePriceText(option, optionValue, ThemeCurrency.moneyFormat) : undefined)}" data-tippy-placement="bottom">
                    ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
                </div>
            </label>
        `;
        const breakTemplate = (optionValue, index) => option.params.items && (index + 1) % option.params.items === 0 ? html`<div class="cl-po--break" data-index=${index}></div>` : null;
        const grouped = swatchGroupTemplate(option, checkboxTemplate, breakTemplate);

        return html`
            <div class="cl-po--swatch-container">
                <input type="hidden" name="${optionName(option)}" id="${option.id}" value=${option.value} form=${ifDefined(config.productFormLink)} />
                ${grouped || repeat(option.values || [], (optionValue) => optionValue.value, (optionValue, index) => html`${checkboxTemplate(optionValue, index)}${breakTemplate(optionValue, index)}`)}
            </div>
        `;

    } else {
        // default radio single selection (swatchToggle function required to support de-selection with radio)
        const radioTemplate = (optionValue, index) => html`
            <label class="cl-po--swatch-item ${classMap(optionValueClassMap(option, optionValue, { grow: option.params.grow }))}" >
                <input type="radio" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" name="${optionName(option)}" .value=${optionValue.value} @change=${(e) => valueSync(e, option, onChange)}
                       .checked=${live(option.value == optionValue.value)} ?required=${option.required} ?disabled=${optionValue.disabled} form=${ifDefined(config.productFormLink)} >
                <div class="cl-po--swatch cl-po--swatch-button ${classMap(sizeClassMap(option, 'small'))}" style=${styleMap(buttonStyleMap(option))} data-tippy-content="${ifDefined(option.params.valuePriceTooltip ? optionValuePriceText(option, optionValue, ThemeCurrency.moneyFormat) : undefined)}" data-tippy-placement="bottom"
                     @click=${(e) => swatchToggle(e, option, optionValue, onChange)}>
                    ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
                </div>
            </label>
        `;
        const breakTemplate = (optionValue, index) => option.params.items && (index + 1) % option.params.items === 0 ? html`<div class="cl-po--break" data-index=${index}></div>` : null;
        const grouped = swatchGroupTemplate(option, radioTemplate, breakTemplate);

        return html`
            <div class="cl-po--swatch-container">
                ${grouped || repeat(option.values || [], (optionValue) => optionValue.value, (optionValue, index) => html`${radioTemplate(optionValue, index)}${breakTemplate(optionValue, index)}`)}
            </div>
        `
    }

};